var render = function render(){var _vm=this,_c=_vm._self._c;return _c('redness-detail-template',{attrs:{"is-duration-visible":_vm.isDurationVisible,"redness-discomfort-frequency":_vm.rednessDiscomfortFrequency,"redness-duration":_vm.rednessDuration,"field-errors":_vm.fieldErrors},on:{"field-change":_vm.onFieldChange}})
}
var staticRenderFns = []

export { render, staticRenderFns }